import { IntlShape } from 'react-intl';

import { EmploymentHistoryEntry } from './EmploymentHistory';
import { messages } from './messages';

// ********************************************************************************
// == Util ========================================================================
const formatYearMonth = (year: string, month: string, intl: IntlShape) => {
  const date = new Date(parseInt(year, 10), parseInt(month, 10) - 1);
  return intl.formatDate(date, { year: 'numeric', month: 'short' });
};

const serializeEntry = (entry: EmploymentHistoryEntry, intl: IntlShape) => {
  const startDate = formatYearMonth(entry.startYear, entry.startMonth, intl);

  const hasEndDate =
    entry.endYear &&
    entry.endMonth &&
    entry.endYear !== '0' &&
    entry.endMonth !== '0';

  let endDate: string;
  if (entry.active === 'on') {
    endDate = intl.formatMessage(messages.present);
  } else if (hasEndDate) {
    endDate = formatYearMonth(entry.endYear, entry.endMonth, intl);
  } else {
    endDate = '';
  }

  const dateRange = `${startDate} - ${endDate}`;

  if (entry.noHistory === 'on') {
    return `${dateRange} | ${intl.formatMessage(messages.noEmployerDetails)}`;
  }

  const employerContactLabel = intl.formatMessage(
    messages.employerContactNameField,
  );

  return `${dateRange} | ${entry.employer_name} ${entry.job_title} ${entry.city}, ${entry.state_code} ${entry.country_code_iso}. ${employerContactLabel}: ${entry.employer_contact_name}`;
};

// == Export ======================================================================
export const serializeEmploymentHistory = (
  entries: EmploymentHistoryEntry[] | null | undefined,
  intl: IntlShape,
): string => {
  if (!Array.isArray(entries) || !entries.length) {
    return '';
  }

  return entries.map(entry => serializeEntry(entry, intl)).join('\n');
};
